import {
  type GraphEdgeSettings,
  defaultEdgeThicknessThresholds,
} from './GraphPreset';
import type {
  PathLookupGraphPreset,
  PathLookupGraphSettings,
} from './PathLookupGraphPreset';

export const PathLookupLoopPreset: GraphEdgeSettings = {
  id: '13ab7e51-3e45-4893-9a10-f08db35d3496',
  name: 'loop',
  type: 'pathLookupEdge',
  grouped: false,
  style: {
    color: '#de5257',
    pattern: 'solid',
    thicknessThresholds: defaultEdgeThicknessThresholds,
  },
  visible: true,
  labels: [],
};

export const FactoryPathLookupSettings: PathLookupGraphSettings = {
  edges: [
    {
      id: '6129bb53-d19d-47ee-8f45-8829073221c1',
      name: 'vxlan',
      type: 'pathLookupEdge',
      grouped: false,
      style: {
        color: '#d4b524',
        pattern: 'solid',
        thicknessThresholds: defaultEdgeThicknessThresholds,
      },
      visible: true,
      labels: ['intName', 'protocol'],
    },
    {
      id: 'f61ad8e8-ce17-11eb-b8bc-0242ac130003',
      name: 'capwap',
      type: 'pathLookupEdge',
      grouped: false,
      style: {
        color: '#d4b524',
        pattern: 'solid',
        thicknessThresholds: defaultEdgeThicknessThresholds,
      },
      visible: true,
      labels: ['intName', 'protocol'],
    },
    {
      id: '7f6aa12d-84da-4481-a968-2119085d2778',
      name: 'gre',
      type: 'pathLookupEdge',
      grouped: false,
      style: {
        color: '#d4b524',
        pattern: 'solid',
        thicknessThresholds: defaultEdgeThicknessThresholds,
      },
      visible: true,
      labels: ['intName', 'protocol'],
    },
    {
      id: 'c24cb567-e4dc-4bcd-8f97-9c614c4bb6cd',
      name: 'esp',
      type: 'pathLookupEdge',
      grouped: false,
      style: {
        color: '#d4b524',
        pattern: 'solid',
        thicknessThresholds: defaultEdgeThicknessThresholds,
      },
      visible: true,
      labels: ['intName', 'protocol'],
    },
    {
      id: 'f79f180a-9997-4931-9724-97e66b61b79c',
      name: 'mpls',
      type: 'pathLookupEdge',
      grouped: false,
      style: {
        color: '#ff9800',
        pattern: 'solid',
        thicknessThresholds: defaultEdgeThicknessThresholds,
      },
      visible: true,
      labels: ['intName', 'protocol'],
    },
    {
      // Must precede ethernetVlan/ethernet: the backbone header is an ethernet
      // header, so the first-match-wins classifier would otherwise colour it as
      // (ethernet) VLAN. See PacketClassifier.getHeaderByType.
      id: 'd3f8a1c2-6b4e-4f9a-8c2d-1e7b9f0a3c5d',
      name: 'spbmBackbone',
      type: 'pathLookupEdge',
      grouped: false,
      style: {
        color: '#9c6ade',
        pattern: 'solid',
        thicknessThresholds: defaultEdgeThicknessThresholds,
      },
      visible: true,
      labels: ['intName', 'protocol'],
    },
    {
      id: 'e75cbfc0-71c1-4026-8803-08b6f52ee26e',
      name: 'ethernetVlan',
      type: 'pathLookupEdge',
      grouped: false,
      style: {
        color: '#99ccff',
        pattern: 'solid',
        thicknessThresholds: defaultEdgeThicknessThresholds,
      },
      visible: true,
      labels: ['intName', 'protocol'],
    },
    {
      id: 'a8092d28-cee8-42f8-8179-79182996b924',
      name: 'ip',
      type: 'pathLookupEdge',
      grouped: false,
      style: {
        color: '#ff99ff',
        pattern: 'solid',
        thicknessThresholds: defaultEdgeThicknessThresholds,
      },
      visible: true,
      labels: ['intName', 'protocol'],
    },
    {
      id: 'b2e1c7a4-5f3a-4c8e-9e2a-7d8f6b1c2e3f',
      name: 'ipv6',
      type: 'pathLookupEdge',
      grouped: false,
      style: {
        color: '#ff99ff',
        pattern: 'solid',
        thicknessThresholds: defaultEdgeThicknessThresholds,
      },
      visible: true,
      labels: ['intName', 'protocol'],
    },
    {
      id: '507051b3-aae8-462d-85c4-d5ba1518a1fd',
      name: 'ethernet',
      type: 'pathLookupEdge',
      grouped: false,
      style: {
        color: '#7aa3cc',
        pattern: 'solid',
        thicknessThresholds: defaultEdgeThicknessThresholds,
      },
      visible: true,
      labels: ['intName', 'protocol'],
    },
    {
      id: '2bee1ab7-8bfe-470e-9e31-6d0e6917f89d',
      name: 'fp',
      type: 'pathLookupEdge',
      grouped: false,
      style: {
        color: '#ff9800',
        pattern: 'solid',
        thicknessThresholds: defaultEdgeThicknessThresholds,
      },
      visible: true,
      labels: ['intName', 'protocol'],
    },
    {
      id: '2e18897e-45c7-4ec8-ae33-bdab14c03f5b',
      name: 'aws',
      type: 'pathLookupEdge',
      grouped: false,
      style: {
        color: '#d4b524',
        pattern: 'solid',
        thicknessThresholds: defaultEdgeThicknessThresholds,
      },
      visible: true,
      labels: ['intName', 'protocol'],
    },
    {
      id: '823d51bb-4ac7-4a71-b3a9-68e05c132507',
      name: 'vcmp',
      type: 'pathLookupEdge',
      grouped: false,
      style: {
        color: '#d4b524',
        pattern: 'solid',
        thicknessThresholds: defaultEdgeThicknessThresholds,
      },
      visible: true,
      labels: ['intName', 'protocol'],
    },

    {
      id: '304c23e5-0119-4460-86c9-4fe077b135f2',
      name: 'meraki-vpn',
      type: 'pathLookupEdge',
      grouped: false,
      style: {
        color: '#d4b524',
        pattern: 'solid',
        thicknessThresholds: defaultEdgeThicknessThresholds,
      },
      visible: true,
      labels: ['intName', 'protocol'],
    },
  ],
  pathLookup: {
    ignoredTopics: [],
    colorDetectedLoops: true,
  },
};

export const FactoryPathLookupPreset: PathLookupGraphPreset = {
  ...FactoryPathLookupSettings,
  id: 'root',
  name: 'System',
  factory: true,
};
